import { Snackbar } from '@mui/material'
import { memo } from 'react'
import { PAPER_HEIGHTS } from '../theme'
import Alert from './Alert'

export type Status = {
    error: boolean
    message: string
} | null

interface StatusSnackbarProps {
    status: Status
    onClose?: () => void
}

const StatusSnackbar = memo<StatusSnackbarProps>(({ status, onClose }) => {
    return (
        <Snackbar
            open={status !== null}
            autoHideDuration={5000}
            onClose={onClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            css={{ zIndex: PAPER_HEIGHTS.tooltip }}
        >
            <Alert
                onClose={onClose}
                severity={status?.error ? 'error' : 'success'}
            >
                {status?.message}
            </Alert>
        </Snackbar>
    )
})

export default StatusSnackbar
